export default "__VITE_ASSET__C4nRz$7S__"